var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4531_12971)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 66,
    r: 50,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4531_12971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9994 42.666C82.8864 42.666 93.3327 53.1124 93.3327 65.9994C93.3327 78.8864 82.8864 89.3327 69.9994 89.3327C57.1124 89.3327 46.666 78.8864 46.666 65.9994C46.666 53.1124 57.1124 42.666 69.9994 42.666ZM69.9994 47.3327C65.0486 47.3327 60.3007 49.2993 56.8 52.8C53.2993 56.3007 51.3327 61.0486 51.3327 65.9994C51.3327 70.9501 53.2993 75.698 56.8 79.1987C60.3007 82.6994 65.0486 84.666 69.9994 84.666C74.9501 84.666 79.698 82.6994 83.1987 79.1987C86.6994 75.698 88.666 70.9501 88.666 65.9994C88.666 61.0486 86.6994 56.3007 83.1987 52.8C79.698 49.2993 74.9501 47.3327 69.9994 47.3327ZM69.9994 51.9993C70.5709 51.9994 71.1225 52.2092 71.5496 52.589C71.9766 52.9688 72.2495 53.4921 72.3164 54.0597L72.3327 54.3327V65.0334L78.649 71.3497C79.0675 71.7696 79.3105 72.333 79.3285 72.9256C79.3466 73.5181 79.1385 74.0953 78.7464 74.54C78.3544 74.9847 77.8077 75.2634 77.2176 75.3196C76.6274 75.3758 76.038 75.2053 75.569 74.8427L75.3497 74.649L68.3497 67.649C67.987 67.2861 67.7541 66.8137 67.687 66.305L67.666 65.9994V54.3327C67.666 53.7138 67.9118 53.1204 68.3494 52.6828C68.787 52.2452 69.3805 51.9993 69.9994 51.9993Z",
    fill: "#154CD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4531_12971",
    x: 0,
    y: 0,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4531_12971"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4531_12971",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4531_12971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(42 38)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.133d78f35fce26a68df7d3e64edfb537.svg";
export { ForwardRef as ReactComponent };